import { render, staticRenderFns } from "./T2HomeBlock1.vue?vue&type=template&id=791f601b"
import script from "./T2HomeBlock1.vue?vue&type=script&lang=js"
export * from "./T2HomeBlock1.vue?vue&type=script&lang=js"
import style0 from "./T2HomeBlock1.vue?vue&type=style&index=0&id=791f601b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports